__turbopack_context__.v({
  "menu": "TaxMenu-module-scss-module__FSTlRa__menu",
  "menu-selected": "TaxMenu-module-scss-module__FSTlRa__menu-selected",
  "menumobile": "TaxMenu-module-scss-module__FSTlRa__menumobile",
});
